import { Link } from 'react-router-dom';

import { Theme, makeStyles, createStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
    },
    item: {
      marginBottom: '45px',
    },
    title: {
      padding: theme.spacing(45, 0), // 上下|右左, 上|右左|下, 上|右|下|左
      textAlign: 'center',
      margin: 'auto',
      // backgroundColor: '#F00',
    },
    link: {
      paddingBottom: theme.spacing(17),
      textAlign: 'center',
      margin: 'auto',
      // backgroundColor: '#0F0',
    },
    offset: theme.mixins.toolbar,
  })
);

function Error() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Grid container>
        <Grid item xs={12} className={classes.item}>
          <Typography variant="h3" className={classes.title}>
            404 not found
          </Typography>

          <Typography variant="body1" className={classes.link}>
            <Link to="/">
              <Typography variant="h5">top</Typography>
            </Link>
          </Typography>
        </Grid>
      </Grid>
    </div>
  );
}

export default Error;
